import React from 'react'

const SupplierPayment = () => {
  return (
    <div>
      Supplier Payment
    </div>
  )
}

export default SupplierPayment
